import StatefulComponent from '../../base/StatefulComponent';
import moment from 'moment';

export default class Notification extends StatefulComponent {
    init() {
        this.onClick = null;
        this.state = {
            listContainer: null,
            notification: null
        }
    }

    /**
     * Set onclick handler for notification.
     *
     * @param {Function} v
     * @returns {Notification}
     */
    setOnClick(v) {
        this.onClick = v;
        return this;
    }

    /**
     * Set onclick handler for dismissing a notification.
     *
     * @param {Function} v
     * @returns {Notification}
     */
    setOnDismissClick(v) {
        this.onDismissClick = v;
        return this;
    }

    /**
     * Handles clicking on the notification, calls this.onClick if set.
     *
     * @param {Event} e
     * @param {Object} notification
     */
    handleClick(e, notification) {
        e.preventDefault();
        e.stopPropagation();

        if (this.onClick && typeof this.onClick === 'function') {
            this.onClick(notification);
        }
    }

    /**
     * Handles clicking on the dismiss button for a notification, calls this.onDismissClick if set.
     *
     * @param {Event} e
     * @param {Object} notification
     */
    handleDismissClick(e, notification) {
        e.preventDefault();
        e.stopPropagation();

        if (this.onDismissClick && typeof this.onDismissClick === 'function') {
            this.onDismissClick(notification);
        }

        this.remove();
    }

    /**
     * Removes notification when element is marked as read.
     */
    remove() {
        this.element.fadeOut('fast', () => {
            this.element.remove();
        });
    }

    render() {
        if (this.state.listContainer && this.state.notification) {
            let {listContainer, notification} = this.state,
                time = moment(notification.Date).fromNow();

            // if no message then just return
            if (!notification.Subject) return;

            this.element = $(`
<div class="notifications__notification">
    <h4 class="notifications__notification-title">${notification.Subject}</h4>
    <div class="notifications__notification-message">
        ${notification.ShortMessage}
    </div>
    <div class="notifications__notification-date">${time}</div>
    <a href="#" class="notifications__notification-dismiss">x</a>
</div>
`);
            if (notification.CallToActionURL && notification.CallToActionURL !== null) {
                this.element.attr('data-call-to-action', notification.CallToActionURL);
            }

            listContainer.append(this.element);
            this.element.on('click', (e) => this.handleClick(e, notification));
            this.element.on('click', '.notifications__notification-dismiss', (e) => this.handleDismissClick(e, notification));
        }
    }
}
